<script>
    export let title = ''
    export let subtitle = ''
</script>

<style>
    .page-header {
        margin-bottom: 20px;
    }

    .page-title {
        font-size: 22px;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.2;
        margin: 0 0 4px;
    }

    .page-subtitle {
        font-size: 13px;
        color: #a0a0a0;
        margin: 0;
    }
</style>

<div class="page-header">
    <h1 class="page-title">{title}</h1>
    {#if subtitle}
        <p class="page-subtitle">{subtitle}</p>
    {/if}
</div>
